export default "__VITE_ASSET__144d2cf5__"